import React from 'react';
import styled from 'styled-components';
import Title from '../../components/title/Title';
import CommonSection from '../../components/commonSection/CommonSection';
import card from '../../../assets/card-apply/cardNewDesign.svg';
import SectionTitle from '../../components/sectionTitle/SectionTitle';
import groceriesIcon from '../../../assets/card-apply/icons/groceries.png';
import onlineIcon from '../../../assets/card-apply/icons/online.png';
import restarurantsIcon from '../../../assets/card-apply/icons/restarurants.png';
import doctorIcon from '../../../assets/card-apply/icons/doctor.png';
import vetIcon from '../../../assets/card-apply/icons/vet.png';
import autoRepairIcon from '../../../assets/card-apply/icons/auto-repair.png';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SThanks = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  padding: ${theme.spacing.large}px 0;
  @media only screen and ${theme.device.laptopS} {
    padding: ${theme.spacing.huge}px 0;
  }
`
);

const SColumn = styled.section(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.large}px;
  @media only screen and ${theme.device.laptopS} {
    flex: 1 0;
    margin-bottom: ${theme.spacing.huge}px;
    & + & {
      margin-right: ${theme.spacing.larger}px;
    }
  }
`
);
const SIcons = styled.section(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  flex: 1 100%;
  @media only screen and ${theme.device.laptopS} {
    flex-direction: row;
  }
`
);

const SIconsColumn = styled.section(
  ({ theme }) => `
  flex: 1 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and ${theme.device.laptopS} {
    justify-content: space-around;
  }
`
);

const SRegisteredMarkSpan = styled.span(
  ({ theme }) => `
  vertical-align:super;
  font-size: ${theme.font.size.small};
`
);

const SBold = styled.span(
  ({ theme }) => `
  font-weight: ${theme.font.weight.bold};
`
);

const SCardImage = styled.img`
  max-width: 100%;
`;
const SIconImage = styled.img``;

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IThanksProps {
  firstName: string;
}

// tslint:disable-next-line:variable-name
const Thanks: React.FC<IThanksProps> = (props) => (
  <SThanks data-dd-privacy={PrivacyOptions.MaskUserInput}>
    <SColumn>
      <CommonSection>
        <SCardImage data-at="cardImage" src={card} alt="Card" />
      </CommonSection>
    </SColumn>
    <SColumn>
      <CommonSection>
        <Title data-at="thanksTitle">
          Great news,
          <span data-at="firstName" data-dd-privacy={PrivacyOptions.Mask}>
            {' '}
            {props.firstName}
          </span>
          –you&apos;re approved for the Sunbit Card.
        </Title>
      </CommonSection>
      <CommonSection>
        <SectionTitle data-at="thanksDescription">
          We're getting your card ready and will notify you when it ships. We’ll also send you an email with important disclosures about your card. Be sure to save that email for your records.
          <br />
          <br />
          <SBold>
            Get ready to start shopping with your card anywhere Visa
            <SRegisteredMarkSpan>&reg;</SRegisteredMarkSpan> is accepted.{' '}
          </SBold>
          <br />
          <br />
          Thank you for using Sunbit!
        </SectionTitle>
      </CommonSection>
    </SColumn>
    <SIcons>
      <SIconsColumn>
        <SIconImage data-at="groceriesIcon" src={groceriesIcon} alt="groceries icon" />
        <SIconImage data-at="onlineIcon" src={onlineIcon} alt="online icon" />
        <SIconImage data-at="restarurantsIcon" src={restarurantsIcon} alt="restarurants icon" />
      </SIconsColumn>
      <SIconsColumn>
        <SIconImage data-at="doctorIcon" src={doctorIcon} alt="doctor icon" />
        <SIconImage data-at="vetIcon" src={vetIcon} alt="vet icon" />
        <SIconImage data-at="autoRepairIcon" src={autoRepairIcon} alt="auto repair icon" />
      </SIconsColumn>
    </SIcons>
  </SThanks>
);

export default Thanks;
